// src/components/Contract/GoogleDriveFileModal.jsx
import React, { useState } from "react";

const GoogleDriveFileModal = ({
  show,
  onClose,
  driveFiles,
  onSelect,
  isFetching,
}) => {
  const [selectedFiles, setSelectedFiles] = useState([]);

  if (!show) return null;

  const toggleSelection = (file) => {
    setSelectedFiles((prev) =>
      prev.some((f) => f.id === file.id)
        ? prev.filter((f) => f.id !== file.id)
        : [...prev, file]
    );
  };

  return (
    <div className="fixed inset-0 z-[9999] bg-black/30 flex justify-center items-center">
      <div className="bg-white rounded-xl shadow-lg w-[480px] max-h-[70vh] overflow-hidden flex flex-col">
        {/* Header */}
        <div className="flex justify-between items-center p-4 border-b border-gray-200">
          <h2 className="text-lg font-semibold text-gray-800">
            Select Google Drive Files
          </h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-sm"
          >
            ✕
          </button>
        </div>

        {/* File list */}
        <div className="flex-1 overflow-auto p-3">
          {isFetching ? (
            <p className="text-gray-500 text-center">Loading files...</p>
          ) : driveFiles.length > 0 ? (
            <ul className="divide-y divide-gray-200">
              {driveFiles.map((file) => (
                <li
                  key={file.id}
                  className={`flex items-center justify-between p-2 rounded-lg cursor-pointer transition ${
                    selectedFiles.some((f) => f.id === file.id)
                      ? "bg-[#8B55DD]/10"
                      : "hover:bg-gray-100"
                  }`}
                  onClick={() => toggleSelection(file)}
                >
                  <div className="flex items-center gap-3">
                    {file.icon ? (
                      <img
                        src={file.icon}
                        alt=""
                        className="w-5 h-5 object-contain"
                      />
                    ) : (
                      <img
                        src="/file-icon.svg"
                        alt="File"
                        className="w-5 h-5"
                      />
                    )}
                    <span className="text-sm text-gray-700 font-medium truncate w-[280px]">
                      {file.name}
                    </span>
                  </div>
                  {selectedFiles.some((f) => f.id === file.id) && (
                    <img
                      src="/check-icon-purple.svg"
                      alt="Selected"
                      className="w-4 h-4"
                    />
                  )}
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-gray-500 text-center">
              No files found in Google Drive.
            </p>
          )}
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-2 border-t border-gray-200 p-3">
          <button
            className="px-4 py-2 rounded-md text-sm bg-gray-100 hover:bg-gray-200 text-gray-700"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className={`px-4 py-2 rounded-md text-sm text-white bg-[#8B55DD] hover:bg-[#7B3CCD] ${
              selectedFiles.length === 0 ? "opacity-60 cursor-not-allowed" : ""
            }`}
            disabled={selectedFiles.length === 0}
            onClick={() => onSelect(selectedFiles)}
          >
            Select {selectedFiles.length > 0 ? `(${selectedFiles.length})` : ""}
          </button>
        </div>
      </div>
    </div>
  );
};

export default GoogleDriveFileModal;
